import React, { useEffect, useState } from "react";
import { useApp } from "@/context/AppContext";
import { Link } from "react-router-dom";
import { ClipboardCheck, ListChecks, Layers, Palette, Users as UsersIcon, Image as ImgIcon, ShoppingBag, XCircle } from "lucide-react";
import { adminStats } from "@/lib/api";

export default function AdminDashboard() {
  const { moderationEnabled } = useApp();
  const [stats, setStats] = useState(null);

  useEffect(() => { adminStats().then(setStats).catch(() => {}); }, []);

  const cards = [
    { label: "Anunțuri active", value: stats?.listings_active ?? "—", icon: ListChecks, to: "/admin/moderation" },
    { label: "În așteptare", value: stats?.listings_pending ?? "—", icon: ClipboardCheck, to: "/admin/moderation", highlight: (stats?.listings_pending || 0) > 0 },
    { label: "Vândute", value: stats?.listings_sold ?? "—", icon: ShoppingBag, to: "/admin/moderation" },
    { label: "Respinse", value: stats?.listings_rejected ?? "—", icon: XCircle, to: "/admin/moderation" },
    { label: "Categorii", value: stats?.categories ?? "—", icon: Layers, to: "/admin/categories" },
    { label: "Utilizatori", value: stats?.users ?? "—", icon: UsersIcon, to: "#" },
    { label: "Imagini stocate", value: stats?.images ?? "—", icon: ImgIcon, to: "/admin/theme" },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl md:text-3xl font-black text-white">Dashboard</h1>
        <p className="text-sm" style={{ color: "var(--amd-text-muted)" }}>Privire de ansamblu asupra activității pe amd64.ro</p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {cards.map((c) => (
          <Link key={c.label} to={c.to} className="amd-card rounded-lg p-4">
            <c.icon className="w-5 h-5" style={{ color: c.highlight ? "var(--amd-primary)" : "#fff" }} />
            <div className="mt-3 text-3xl font-black" style={{ color: c.highlight ? "var(--amd-primary)" : "#fff" }}>{c.value}</div>
            <div className="text-xs mt-1" style={{ color: "var(--amd-text-muted)" }}>{c.label}</div>
          </Link>
        ))}
      </div>

      <div className="amd-card rounded-lg p-5">
        <div className="flex items-center justify-between">
          <div>
            <div className="font-bold text-white flex items-center gap-2"><Palette className="w-4 h-4" /> Temă & Stocare</div>
            <p className="text-xs mt-1" style={{ color: "var(--amd-text-muted)" }}>Schimbă culorile site-ului și locul în care se salvează imaginile.</p>
          </div>
          <Link to="/admin/theme" className="amd-btn-primary px-4 h-10 rounded-md inline-flex items-center font-semibold text-sm">Personalizează</Link>
        </div>
      </div>

      <div className="amd-card rounded-lg p-5">
        <div className="flex items-center justify-between">
          <div>
            <div className="font-bold text-white">Moderare manuală</div>
            <p className="text-xs mt-1" style={{ color: "var(--amd-text-muted)" }}>
              {moderationEnabled ? "Activată. Anunțurile noi așteaptă aprobare." : "Dezactivată. Anunțurile noi sunt publicate instant."}
            </p>
          </div>
          <Link to="/admin/moderation" className="px-4 h-10 rounded-md inline-flex items-center font-semibold text-sm border-2 text-white hover:bg-white/5" style={{ borderColor: "#444" }}>Setare</Link>
        </div>
      </div>
    </div>
  );
}
